// extracted by mini-css-extract-plugin
module.exports = {"title":"Complete_title__2Rj7I","searchrow":"Complete_searchrow__2P-t_","quesInfo":"Complete_quesInfo__1IHCM"};